import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { OwnerListRequestBody, OwnerListResponse } from "./types";

export class OwnerListAPI extends BaseAPI<
    OwnerListRequestBody,
    OwnerListResponse
> {
    protected route = ApiRoutes.owner.list;
    protected method = RequestMethod.GET;
    protected params = ["page", "page_size", "name"];
}
